export const ACTIVATION_TEAM_PHONES = [
  '5562986510948', // Primeiro número da equipe
  '558312964700'   // Segundo número da equipe
];

export function sendWhatsAppMessage(phone: string, message: string) {
  const encodedMessage = encodeURIComponent(message);
  window.open(`https://wa.me/${phone}?text=${encodedMessage}`, '_blank');
}

export function notifyActivationTeam(driverData: {
  name: string;
  cpf: string;
  email: string;
  city: string;
  score: number;
}) {
  const message = `
🚗 *Novo Motorista Certificado*

*Nome:* ${driverData.name}
*CPF:* ${driverData.cpf}
*Email:* ${driverData.email}
*Cidade:* ${driverData.city}
*Aproveitamento:* ${driverData.score.toFixed(1)}%

Por favor, analisar os dados para ativação no app.
  `.trim();

  // Enviar para todos os números da equipe
  ACTIVATION_TEAM_PHONES.forEach(phone => {
    sendWhatsAppMessage(phone, message);
  });
}

export function sendCongratulationsMessage(phone: string, name: string, score: number) {
  const message = `
🎉 *Parabéns ${name}!*

Você concluiu o treinamento da Zumm Delivery com ${score.toFixed(1)}% de aproveitamento.

Em breve nossa equipe entrará em contato para prosseguir com sua ativação no app.

Agradecemos seu interesse em fazer parte do nosso time! 🚀
  `.trim();

  sendWhatsAppMessage(phone, message);
}